export const ROUTES = {
  HOME: "platzi",  
  CART: "platzi/cart",
  PROFILE: "platzi/profile",
  CATEGORY: "platzi/categories/:id",
  PRODUCT: "platzi/products/:productId",
}